"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.demoDashboardRoutes = void 0;
exports.demoDashboardRoutes = {
    clips: () => '/demo-campaign-clips',
    creators: () => '/demo-campaign-creators',
    campaign: () => '/demo-campaign-dashboard',
};
